import React from 'react';
import Config from 'config';

import PrivacyPolicyView from './view';

const PrivacyPolicy = () => {
  const name = Config.DISPLAY_NAME;
  return <PrivacyPolicyView name={name} />;
};

export default PrivacyPolicy;
